import { ref, watch, type Ref } from 'vue';

export const useLoad = () => {
  const loading = ref(false);
  const error = ref(false);
  const onStart = () => {
    error.value = false;
    loading.value = true;
  };
  const onSuccess = () => {
    error.value = false;
    loading.value = false;
  };
  const onError = () => {
    error.value = true;
    loading.value = false;
  };

  return {
    loading,
    error,
    onStart,
    onSuccess,
    onError,
  };
};

export const useLoadImage = (src: Ref<string>) => {
  const {
    loading, error, onStart, onSuccess, onError,
  } = useLoad();

  const onLoad = (url: string) => {
    onStart();
    const newImg = new Image();
    newImg.onload = () => { onSuccess(); };
    newImg.onerror = () => { onError(); };
    newImg.src = url;
  };
  onLoad(src.value);
  watch(src, () => onLoad(src.value));

  return { loading, error };
};

export const useLoadIframe = (src: Ref<string>, init?: RequestInit) => {
  const {
    loading, error, onStart, onSuccess, onError,
  } = useLoad();

  const onLoad = (url: string) => {
    onStart();
    fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/pdf' },
      credentials: 'include',
      ...init,
    })
      .then((response) => {
        if (response.status === 200) {
          onSuccess();
        } else {
          onError();
        }
      })
      .catch(() => {
        onError();
      });
  };
  onLoad(src.value);
  watch(src, () => onLoad(src.value));

  return { loading, error };
};
